import { globalTranslate } from '@pfsc/shared/locale/app.i18n';
import { appConfig } from '../services/app.config';

export const DEFAULT_LEARNER_COLUMNS = [
  {
    title: globalTranslate('header.userId'),
    key: 'id',
    sortable: false,
    align: 'left',
  },
  {
    title: globalTranslate('header.firstName'),
    key: 'firstName',
    sortable: false,
    align: 'left',
  },
  {
    title: globalTranslate('header.lastName'),
    key: 'lastName',
    sortable: false,
    align: 'left',
    width: 250,
  },
  {
    title: globalTranslate('header.status'),
    key: 'status',
    sortable: false,
    align: 'left',
  },
  {
    title: globalTranslate('header.emailAddress'),
    key: 'email',
    sortable: false,
    align: 'left',
  },
];

export const SHORT_WITH_USER_ID_LEARNER_COLUMNS = [
  {
    title: globalTranslate('header.userId'),
    key: 'id',
    sortable: true,
    align: 'left',
    minWidth: 110,
  },
  {
    title: globalTranslate('header.firstName'),
    key: 'firstName',
    sortable: false,
    align: 'left',
    minWidth: 140,
  },
  {
    title: globalTranslate('header.lastName'),
    key: 'lastName',
    sortable: true,
    align: 'left',
    minWidth: 140,
  },
  {
    title: globalTranslate('header.emailAddress'),
    key: 'email',
    sortable: false,
    align: 'left',
    minWidth: 250,
  },
];

export const SHORT_LEARNER_COLUMNS = [
  {
    title: globalTranslate('header.lastName'),
    key: 'lastName',
    sortable: false,
    align: 'left',
    minWidth: 140,
  },
  {
    title: globalTranslate('header.firstName'),
    key: 'firstName',
    sortable: false,
    align: 'left',
    minWidth: 140,
  },
  {
    title: globalTranslate('header.emailAddress'),
    key: 'email',
    sortable: false,
    align: 'left',
    minWidth: 300,
  },
];

const RBS_SERVER_ID_COLUMN = {
  title: globalTranslate('header.serverId'),
  key: 'rbsServerId',
  sortable: false,
  align: 'left',
};

export const REMOVABLE_LEARNER_COLUMNS = [
  ...DEFAULT_LEARNER_COLUMNS.flatMap(column => (
    column.key === 'lastName' ? [column, RBS_SERVER_ID_COLUMN] : [column]
  )),
  {
    title: '',
    key: 'delete',
    sortable: false,
    align: 'center',
  },
];

export const INTERACTIVE_LEARNER_COLUMNS = [
  ...DEFAULT_LEARNER_COLUMNS,
  {
    title: '',
    key: 'assign',
    sortable: false,
    align: 'center',
  },
];

export const EDITABLE_LEARNER_COLUMNS = [
  ...DEFAULT_LEARNER_COLUMNS,
  {
    title: '',
    key: 'assign',
    sortable: false,
    align: 'center',
  },
  {
    title: '',
    key: 'delete',
    sortable: false,
    align: 'center',
  },
];

export const TEST_LEARNER_COLUMNS = appConfig.isDevelopment ? [
  {
    title: 'Username',
    key: 'username',
    sortable: false,
    align: 'center',
  },
  ...DEFAULT_LEARNER_COLUMNS,
  {
    title: '',
    key: 'assign',
    sortable: false,
    align: 'center',
  },
  {
    title: '',
    key: 'delete',
    sortable: false,
    align: 'center',
  },
] : [];

/**
 * Get learners columns with additional fields
 * @param {object} params Params.
 * @param {Array} [params.defaultColumns] Default columns.
 * @param {boolean} [params.hasDobColumn] Whether columns should include dob column.
 * @param {boolean} [params.hasRbsColumn] Whether columns should include rbs column.
 * @param {boolean} [params.hasNoteColumn] Whether columns should include note column.
 * @param {boolean} [params.hasAssignColumn] Whether columns should include note column.
 * @param {boolean} [params.hasEmployeeIdColumn] Whether columns should include employee id column.
 * @returns {Array}
 */
export function getLearnersColumnsWithAdditionalFields({
  defaultColumns: initialColumns,
  hasDobColumn = false,
  hasRbsColumn = false,
  hasNoteColumn = false,
  hasAssignColumn = false,
  hasEmployeeIdColumn = false,
}) {
  const defaultColumns = initialColumns ? [...initialColumns] : [...DEFAULT_LEARNER_COLUMNS];
  if (hasEmployeeIdColumn) {
    defaultColumns.push({
      title: globalTranslate('assignment.employeeId'),
      key: 'employeeId',
      sortable: false,
      align: 'left',
    });
  }
  if (hasDobColumn) {
    defaultColumns.push({
      title: globalTranslate('addNewLearnerDialog.dob'),
      key: 'dateOfBirth',
      sortable: false,
      align: 'left',
      width: 250,
      minWidth: 200,
    });
  }
  if (hasRbsColumn) {
    defaultColumns.push({
      title: globalTranslate('assignment.serverId'),
      key: 'rbsServerId',
      sortable: false,
      align: 'left',
      width: 250,
      minWidth: 250,
    });
  }
  if (hasNoteColumn) {
    defaultColumns.push({
      title: globalTranslate('header.instructorNotes'),
      key: 'instructorNotes',
      sortable: false,
      align: 'left',
      width: 250,
      minWidth: 150,
    });
  }
  if (hasAssignColumn) {
    defaultColumns.push({
      title: '',
      key: 'assign',
      sortable: false,
      align: 'center',
    });
  }
  return defaultColumns;
}
